import config from './config';

// The consignment agreement and tips are uploaded on the admin Site content page and served by the public site
export function documentUrl(docId) {
  return `${config.SITE_URL}/documents/${docId}.pdf`;
}
